import {Typography} from "@material-ui/core"

export default function PlaceholderCard() {
    return <div class="request-container placeholder-request-container">
        <Typography variant='h4'>Select an Account</Typography>
    </div>
}